<template>
  <div>
    <v-dialog v-model="show" persistent max-width="600px" width="100%">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>تعديل صرفية</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 10px"></div>
          <v-row>
            <v-col cols="12">
              <v-text-field disabled rounded outlined type="number" v-model="itemToEdit.expensesAmount" label="مبلغ الصرفية"></v-text-field>

              <v-autocomplete disabled rounded v-model="itemToEdit.currencyId" :items="currencies" item-text="currencyName" item-value="idCurrency" outlined label="العملة"></v-autocomplete>

              <v-autocomplete rounded v-model="itemToEdit.generationTypeId" :items="types" item-text="typeName" item-value="idGenerationType" outlined label="التبويب"></v-autocomplete>

              <v-autocomplete
                rounded
                disabled
                v-model="itemToEdit.generationBenefitId"
                :items="benefits"
                item-text="benefitName"
                item-value="idGenerationBenefit"
                outlined
                label="الجهة المستفيدة"
              ></v-autocomplete>

              <v-text-field rounded disabled outlined type="date" v-model="itemToEdit.dateFormat" label="تاريخ الصرفية"></v-text-field>

              <v-textarea rounded rows="3" row-height="15" outlined v-model="itemToEdit.expensesNote" name="input-7-4" label="الملاحظات"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="saveData"> حفظ </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon @click="show = true" color="edit" v-bind="attrs" v-on="on"> mdi-pencil-circle </v-icon>
      </template>
      <span>تعديل صرفية</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    itemToEdit: Object,
    currencies: Array,
    benefits: Array,
    types: Array,
  },
  data: () => ({
    show: false,
    overlay: false,

    showDate: false,
    expensesDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),

    generationTypeId: "",
    expensesNote: "",
    currencyId: "",
    benefitId: "",
  }),
  created() {
    console.log(this.itemToEdit);
    this.itemToEdit.dateFormat = this.itemToEdit.expensesDate.split("T")[0];
  },

  methods: {
    saveData() {
      let self = this;

      let data = {
        expensesDate: self.itemToEdit.expensesDate,
        expensesAmount: self.itemToEdit.expensesAmount,
        generationTypeId: self.itemToEdit.generationTypeId,
        expensesNote: self.itemToEdit.expensesNote,
        currencyId: self.itemToEdit.currencyId,
        generationBenefitId: self.itemToEdit.generationBenefitId,
        isValid: 1,
        createdBy: self.$store.state.userData.idUser,
      };

      self.$http
        .put(`${self.$store.state.apiUrl}/generationExpenses/${self.itemToEdit.idGenerationExpenses}`, data, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          console.log(res.data);

          this.$toasted.success("تم تعديل البيانات");
          this.$emit("reloadTask");
        });

      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
